import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

interface LottiePreviewProps {
  src: string;
  width?: number | string;
  height?: number | string;
  loop?: boolean;
  autoplay?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

const LottiePreview: React.FC<LottiePreviewProps> = ({
  src,
  width = '100%',
  height = '100%',
  loop = true,
  autoplay = true,
  style,
  className,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<any>(null);

  useEffect(() => {
    if (!containerRef.current || !src) return;

    // 清理之前的动画
    if (animationRef.current) {
      animationRef.current.destroy();
      animationRef.current = null;
    }

    // 加载 Lottie 动画
    const loadAnimation = async () => {
      try {
        const response = await fetch(src);
        const animationData = await response.json();

        if (containerRef.current) {
          animationRef.current = lottie.loadAnimation({
            container: containerRef.current,
            renderer: 'svg',
            loop,
            autoplay,
            animationData,
          });
        }
      } catch (error) {
        console.error('加载 Lottie 动画失败:', error);
        // 如果加载失败，显示错误信息
        if (containerRef.current) {
          containerRef.current.innerHTML = `
            <div style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 100%;
              color: #999;
              font-size: 12px;
            ">
              <div>⚠️</div>
              <div>动画加载失败</div>
            </div>
          `;
        }
      }
    };

    loadAnimation();

    // 清理函数
    return () => {
      if (animationRef.current) {
        animationRef.current.destroy();
        animationRef.current = null;
      }
    };
  }, [src, loop, autoplay]);
  // jpg", "jpeg", "png", "webp", "gif", "svga" ,"lottie
  return (
    <div
      ref={containerRef}
      style={{
        width,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      className={className}
    />
  );
};

export default LottiePreview;

